export default {
  "notifications": {
    "broken_favorite": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Neznámý příspěvek, hledám jej…"])},
    "favorited_you": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["si oblíbil/a váš příspěvek"])},
    "followed_you": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["vás nyní sleduje"])},
    "load_older": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Načíst starší oznámení"])},
    "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oznámení"])},
    "read": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Číst!"])},
    "repeated_you": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["zopakoval/a váš příspěvek"])},
    "no_more_notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Žádná další oznámení"])}
  }
}